import _ from "lodash";
import { ivAdminTypes, TM_IV_ROUTE_TYPES, BRANDED_TERM_TYPES } from "../constant/drugs";
import moment from "moment-timezone";

// [DRUGS-TODO-YUVAL]: Remove once all RxnormDrug references have been switched to using tmRouteType:
export const isIvType = (adminType) => {
  return adminType && ivAdminTypes.includes(adminType.toLowerCase());
};

export const formatRxnormDrugLabelForSearch = (pinName, bnName) => {
  return bnName ? `${pinName} (${bnName})` : pinName;
};

export const isRxNormDrugIVAdministered = ({ tmRouteType }) => TM_IV_ROUTE_TYPES.includes(tmRouteType);
export const isRxNormDrugBranded = ({ tty }) => Object.values(BRANDED_TERM_TYPES).includes(tty);

export const formatPapRxnormDrugName = (rxnormDrug) =>
  rxnormDrug?.bnName || rxnormDrug?.pinName.split("|").join(" + ") || "";

export const algorithmOneDrugsSorting = (drugs) =>
  drugs.sort((a, b) => {
    if (a.label === b.label) {
      return (a.bnName || "").localeCompare(b.bnName || "", { numeric: true });
    } else {
      return a.label.localeCompare(b.label, { numeric: true });
    }
  });

export const getAPDrugDisplayName = (rxnormDrug) => {
  const { bnName, pinName, dfName } = rxnormDrug;

  let displayName = pinName.split("|").join(" + ");

  if (bnName) {
    displayName = `${bnName} (${displayName})`;
  }

  if (dfName) {
    displayName = `${displayName} ${dfName}`;
  }

  return displayName;
};

export const getActiveDrugs = (patientMedications) => {
  if (!patientMedications) return [];

  const activeDrugEvents = patientMedications?.map(({ drugEntries }) => {
    if (!drugEntries?.length) return [];

    const relevantDrugs =
      drugEntries?.filter((drugEntry) => {
        const relevantDates = [];
        const { numberOfCycles, daysBetweenCycles, cycle, numberOfRefillsAuthorized, date } = drugEntry;
        const cyclesAmount = numberOfCycles || numberOfRefillsAuthorized || 1;

        if (cyclesAmount === 1) {
          return moment(date).isBetween(moment().subtract(6, "month"), moment().add(6, "month"));
        }

        relevantDates.push(moment(date));
        for (let i = cycle + 1; i <= cyclesAmount; i++) {
          relevantDates.push(moment(date).add(daysBetweenCycles * i, "d"));
        }

        const isDateWithinHalfYearRange = relevantDates.find((date) =>
          moment(date).isBetween(moment().subtract(6, "month"), moment().add(6, "month"))
        );
        return isDateWithinHalfYearRange;
      }) || [];
    return relevantDrugs;
  });

  const activeDrugsEventsFiltered = _.flatten(activeDrugEvents);
  const activeDrugs = activeDrugsEventsFiltered.map(({ rxnormDrug }) => {
    const { bnName, pinName } = rxnormDrug;
    const pinDisplayName = pinName.split("|").join(" + ");

    return {
      ...rxnormDrug,
      label: bnName ? `${bnName} (${pinDisplayName})` : pinDisplayName
    };
  });

  const uniqActiveDrugs = _.uniqBy(activeDrugs, "id");

  return uniqActiveDrugs;
};
